function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M16 7a1 1 0 0 1 1 1v9.586l2.293-2.293.094-.083a1 1 0 0 1 1.32 1.497l-4 4-.094.083a1 1 0 0 1-1.32-.083l-4-4-.083-.094a1 1 0 0 1 .083-1.32l.094-.083a1 1 0 0 1 1.32.083L15 17.586V8a1 1 0 0 1 1-1M8.613 3.21l.094.083 4 4a1 1 0 0 1-1.32 1.497l-.094-.083L9 6.414V16a1 1 0 0 1-2 0V6.414L4.707 8.707a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 4-4a1 1 0 0 1 1.32-.083"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-swap.svg";
export { SvgComponent as ReactComponent };